import React, { memo } from 'react';
import { StyleSheet } from 'react-native';

import { appTheme } from '@/components/lib/theme';

import { useResizeImage } from '../hooks/use-resize-image.web';
import '../playerImage.css';
import { GeneralImageCanvasProps, TilesImageCanvasProps } from '../types';
import {
    borderWidth,
    containerHeight,
    playerImageSize,
    playerImageYOffset,
    teamColorCircle,
    tilePaddingTop,
} from './utils';

export const TilePlayerImageCanvas = memo(
    ({
        teamColor,
        bgColor,
        source,
        hideImage,
        containerWidth,
        onError,
    }: GeneralImageCanvasProps & TilesImageCanvasProps) => {
        const imageSource = useResizeImage({ source });

        return (
            <div style={{ width: containerWidth, ...styles.canvas }}>
                <svg
                    width={'100%'}
                    height={'100%'}
                    fill="none"
                    className="playerTeamColorBlur"
                    style={{ clipPath: `inset(0 round 16px)` }}
                >
                    <g>
                        <circle
                            cx={containerWidth}
                            cy={0}
                            r={teamColorCircle.radius}
                            fill={teamColor || appTheme.colors[bgColor]}
                        />
                    </g>
                </svg>
                {!hideImage && imageSource ? (
                    <div style={styles.imageContainer}>
                        <img
                            alt=""
                            src={imageSource}
                            className="playerImage"
                            style={{ width: playerImageSize.width, height: playerImageSize.height }}
                            onError={onError}
                        />
                    </div>
                ) : null}
            </div>
        );
    }
);

const styles = StyleSheet.create({
    canvas: {
        position: 'absolute',
        top: -tilePaddingTop - borderWidth,
        height: containerHeight + playerImageYOffset + borderWidth,
    },

    imageContainer: {
        position: 'absolute',
        top: playerImageYOffset,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
});
